import Header from './Headers';

import Config from '../config/config';
import Const from '../util/Constants';

class ProductAPI {
  
  static list = (success, failure) => {
    fetch(Config.app.link + 'api/product', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static search = (text, success, failure) => {
    fetch(Config.app.link + 'api/product/search/' + text, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/product/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (product, success, failure) => {
    fetch(Config.app.link + 'api/product', new Header('POST', product))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/product/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static listCategory = (success, failure) => {
    fetch(Config.app.link + 'api/product/category', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static saveCategory = (category, success, failure) => {
    fetch(Config.app.link + 'api/product/category', new Header('POST', category))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static deleteCategory = (id, success, failure) => {
    fetch(Config.app.link + 'api/product/category/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static listUnitMeasure = (success, failure) => {
    fetch(Config.app.link + 'api/product/unit-measure', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static saveUnitMeasure = (category, success, failure) => {
    fetch(Config.app.link + 'api/product/unit-measure', new Header('POST', category))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static deleteUnitMeasure = (id, success, failure) => {
    fetch(Config.app.link + 'api/product/unit-measure/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default ProductAPI;